import React from 'react';
import { Div, Divider, Skeleton } from '@pezeshk-book/ui-kit';
import ArrowDownIcon from '@icons-components/arrow-down-icon';

const DoctorItemSkeleton = () => {
  return (
    <>
      <Div className={'w-full justify-end flex-col z-[3] mb-2 bg-white'}>
        <Div className={'w-full flex-col'}>
          <Div className={'relative w-full pt-3 px-9 justify-between'}>
            <Div className={'justify-between'}>
              <Div className={'ml-1 gap-5 md:gap-10'}>
                <Div className={'items-center flex-col'}>
                  <Skeleton color={'control'} className={'w-[101px] !h-[101px] rounded-full !max-w-full'} shape={'circle'}/>
                  <Skeleton color={'control'} className={'w-full !h-5 rounded-md mt-2.5 !max-w-full'} shape={'rectangular'}/>
                </Div>
                <Div className={'items-end mt-4 gap-4 flex-col'}>
                  <Skeleton color={'control'} className={'rounded-lg !w-[180px] h-4 !max-w-full'} shape={'rectangular'}/>
                  <Skeleton color={'control'} className={'rounded-lg !w-[180px] h-4 !max-w-full'} shape={'rectangular'}/>
                  <Skeleton color={'control'} className={'rounded-lg !w-[180px] h-4 !max-w-full'} shape={'rectangular'}/>
                </Div>
              </Div>
            </Div>
            <Div className={'flex-col mt-4 mb-1 gap-3'}>
              <Skeleton color={'control'} shape={'rectangular'} className={'w-[180px] h-12 rounded-lg !max-w-full'}/>
              <Skeleton color={'control'} shape={'rectangular'} className={'w-[180px] h-12 rounded-lg !max-w-full'}/>
            </Div>
          </Div>
          <Div className={'w-11/12 self-center py-5'}>
            <Divider color={'control'}/>
          </Div>
          <Div className={'sm:pr-12 sm:mt-3 w-full md:pr-16'}>
            <Div className={'mb-4 items-center self-center justify-center mr-3 md:mr-32 mt-4'}>
              <Skeleton color={'control'} size={'tiny'} className={'w-20 !max-w-full'}/>
            </Div>
          </Div>
          <Div className={'self-center w-full h-12 items-end justify-center'}>
            <Div className={'self-center relative w-5 h-3'}>
              <ArrowDownIcon/>
            </Div>
          </Div>
        </Div>
      </Div>
    </>
  );
};

export default DoctorItemSkeleton;
